import { TreeSectionProps } from './tree.types';

const sectionHeaderClasses = 'bg-gray-50 border-gray-200 border-y px-2.5 py-1 text-gray-900 font-medium';
const sectionBodyClasses = 'py-1';

export const TreeSection = (props: TreeSectionProps) => {
  return (
    <>
      <div className={sectionHeaderClasses}>{props.title}</div>
      <div className={sectionBodyClasses}>{props.children}</div>
    </>
  );
};
